import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Label } from "@progress/kendo-react-labels";
import { Input } from "@progress/kendo-react-inputs";
import { getYearEnd } from "api";
import { toast } from "react-toastify";

const YearEnd = () => {
  const [authCode, setAuthCode] = useState("");

  const currentYear = {
    start: "1 Jan 2024",
    end: "31 Dec 2024",
  };

  const nextYear = {
    start: "1 Jan 2024",
    end: "31 Dec 2024",
  };

  const handleYearEnd = async () => {
    try {
      const response = await getYearEnd({
        currentYear: 2024,
        authorisationCode: 1001,
      });

      if (response.status === 200) {
        toast.success("Year end process completed successfully");
      }
    } catch (error) {
      toast.error("Failed to process year end");
    }
  };

  return (
    <div
      className="mx-auto p-5 rounded-3 my-5 d-flex flex-column"
      style={{
        width: "600px",
        height: "350px",
        boxShadow: "0 4px 24px rgba(34, 34, 87, 0.10)",
      }}
    >
      <div className="flex-grow-1">
        <div className="d-flex flex-column">
          <Label className="my-1">Current Financial Year</Label>
          <Input
            placeholder="Enter Current Financial Year"
            type="text"
            value={`${currentYear.start} to ${currentYear.end}`}
          />
        </div>
        <div className="d-flex flex-column my-3">
          <Label className="my-1">Next Financial Year</Label>
          <Input
            placeholder="Enter Next Financial Year"
            type="text"
            value={`${nextYear.start} to ${nextYear.end}`}
          />
        </div>
      </div>
      <div className="d-flex justify-content-end align-items-end mt-5">
        <Button onClick={handleYearEnd} className="common-btn">
          Run Year End
        </Button>
      </div>
    </div>
  );
};

export default YearEnd;
